import React from 'react';
import './ShopScreen.css';

//Data source
import Data from '../../Data';

//components
import Nav from '../../Components/Nav/Nav';
import Footer from '../../Components/Footer/Footer';
import ItemCards from '../../Components/ItemCard/ItemCard';
import Cookie  from 'js-cookie';

//  make the tablet and desktop view for the contact route && if possible try finish the views for the about route as well;


function ShopScreen(props) {

    const currentCookies = JSON.parse(Cookie.get('lastViewed'));
    console.log(currentCookies)

    let AllData = [];

    for (let i in Data) {
        AllData.push(...Data[i]);
    }

    return (
        <>
            <Nav />
            <div className="shop-screen">
                <div className="shop__item__container">
                    <div className="container__content">
                        <ItemCards route={true} data={AllData} />
                    </div>
                </div>
                <div className='shop__item__pagination'>

                </div>
            </div>
            <Footer />
        </>
    )
}

export default ShopScreen
